import { IdMap, RMap, RMutableMap, RSet, toPairs } from "../collections";
import { makeImmutable, Money } from "../core";
import { ModifierItemTypeId, ModifierTypeId, PackagingContainerType, PackagingContainerTypeId, ProductTypeId, } from "../ordering";
import { VolumeParser } from "./VolumeParser";
export class PackagingContainerParser {
    constructor(params) {
        this.catalogue = params.catalogue;
        makeImmutable(this);
    }
    parse() {
        const containers = RMap.fromIterable(toPairs(this.catalogue.packagingContainers)
            // NOTICE The backend drops disabled containers from the packaging
            // demand it validates against and rejects an assignment that uses one,
            // so they must not be candidates here either.
            .filtered(([_, container]) => container.enabled)
            .map(([id, container]) => [
            new PackagingContainerTypeId(id),
            {
                price: Money.fromBackend(container.price),
                capacity: VolumeParser.parse(container.capacity),
                allowedProductTypes: [],
                allowedModifierItemTypes: RMutableMap.empty({
                    makeAutoObservable: false,
                }),
            },
        ]));
        toPairs(this.catalogue.products).forEach(([id, product]) => {
            var _a, _b;
            const productId = new ProductTypeId(id);
            const productCategory = this.catalogue.categories[product.category];
            // NOTICE A product-level override replaces the category config wholesale
            // (the backend's `override <|> category`), even when it allows no
            // containers at all - falling back to the category here would pack a
            // product the backend demands no packaging for.
            const containersConfig = (_a = product.packagingContainersConfigOverride) !== null && _a !== void 0 ? _a : productCategory.packagingContainersConfig;
            ((_b = containersConfig === null || containersConfig === void 0 ? void 0 : containersConfig.allowedContainers) !== null && _b !== void 0 ? _b : []).forEach((containerId) => {
                var _a;
                (_a = containers.rawFind(containerId)) === null || _a === void 0 ? void 0 : _a.allowedProductTypes.push(productId);
            });
        });
        toPairs(this.catalogue.modifiers).forEach(([modifierId, modifier]) => {
            const modifierTypeId = new ModifierTypeId(modifierId);
            modifier.sections.forEach((section) => {
                section.items.forEach(([itemId, modifierItemType]) => {
                    var _a, _b;
                    const modifierItemTypeId = new ModifierItemTypeId(itemId);
                    const modifierItemContainers = (_b = (_a = modifierItemType.packagingContainersConfig) === null || _a === void 0 ? void 0 : _a.allowedContainers) !== null && _b !== void 0 ? _b : [];
                    modifierItemContainers.forEach((containerId) => {
                        var _a;
                        (_a = containers
                            .rawFind(containerId)) === null || _a === void 0 ? void 0 : _a.allowedModifierItemTypes.getOrCreate(modifierTypeId, () => []).push(modifierItemTypeId);
                    });
                });
            });
        });
        return IdMap.fromIterable(containers.entries.map(([id, params]) => new PackagingContainerType({
            id,
            ...params,
            allowedProductTypes: RSet.fromIterable(params.allowedProductTypes, {
                ignoreDuplicates: true,
            }),
            allowedModifierItemTypes: params.allowedModifierItemTypes
                .freeze()
                .map((allowedModifierItemTypes) => RSet.fromIterable(allowedModifierItemTypes, {
                ignoreDuplicates: true,
            })),
        })));
    }
}
